var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PageWrapper", {
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "upload-container" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "el-icon-plus custom-btn",
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.handleAdd },
                  },
                  [_vm._v("新增汇率")]
                ),
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.listLoading,
                        expression: "listLoading",
                      },
                    ],
                    staticClass: "customer-table",
                    attrs: {
                      border: "",
                      fit: "",
                      "highlight-current-row": "",
                      data: _vm.list,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "币种（中文名称）",
                        prop: "currency_name",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "币种（英文代码）", prop: "currency" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "汇率", prop: "rate" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作", width: "200" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-popconfirm",
                                {
                                  attrs: {
                                    iconColor: "red",
                                    title: "确认删除此条数据吗？",
                                  },
                                  on: {
                                    confirm: function ($event) {
                                      return _vm.handleDelete(
                                        scope,
                                        scope.$index
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "el-icon-delete",
                                      attrs: {
                                        slot: "reference",
                                        size: "small",
                                        type: "danger",
                                      },
                                      slot: "reference",
                                    },
                                    [_vm._v("删除")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _c("el-pagination", {
                  staticStyle: {
                    "margin-top": "14px",
                    "margin-bottom": "14px",
                  },
                  attrs: {
                    "current-page": _vm.selectPage.pageNum,
                    "page-sizes": [20, 50, 100, 200],
                    "page-size": _vm.selectPage.pageSize,
                    background: "",
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.allNum,
                  },
                  on: {
                    "size-change": _vm.pageSizeChange,
                    "current-change": _vm.pageCurrentChange,
                  },
                }),
                _c("Edit", {
                  attrs: {
                    dialog: _vm.dialog,
                    "form-data": _vm.editFormData,
                    type: _vm.type,
                    submitLoading: _vm.submitLoading,
                  },
                  on: { submit: _vm.handleSubmit, close: _vm.handleClose },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }